// extracted by mini-css-extract-plugin
module.exports = {"cls1":"_404-Description-module--cls1--2ovSe","cls2":"_404-Description-module--cls2--2rEgD _404-Description-module--cls1--2ovSe"};